#import "./PolicyAdminFields.graphql"
#import "./PolicyReviewFields.graphql"
#import "./PolicyDocumentFields.graphql"

fragment PolicyDetailFields on PolicyAdmin {
  ...PolicyAdminFields
  summary
  keyPoints
  reviews {
    ...PolicyReviewFields
  }
  currentDocument {
    ...PolicyDocumentFields
    pages {
      number
      text
    }
  }
  documents {
    ...PolicyDocumentFields
  }
  acknowledgements {
    appliesTo
    acknowledged
    outstanding {
      employeeId
      name
      dueOn
      overdue
    }
  }
}
